(function() {
    'use strict';
    
a3_pilot_reports.controller('SelectedFlightCtrl', SelectedFlightCtrl);
    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name SelectedFlightCtrl
    * @description 
    *   Show selected Flight info page
    * @ngInject
    */ 
function SelectedFlightCtrl($scope,  $routeParams, defaultCalendarDate, SearchFlightsFactory, $timeout, showRecomendedWaterAcTypes) {			
    
    //get value from routeParams:
    var flightId = $routeParams.flightId;
    var flightDate = $routeParams.flightDate;
    var flightNo = $routeParams.flightNo;
    var departure = $routeParams.departure;

    window.addEventListener('online', function (e) { $timeout(checkConnectionStatus()); });
    $scope.init = checkConnectionStatus();
    $scope.contentToShow = "loading";
    $scope.flightInfo = null;
    $scope.hasFlightInfo = false;
    $scope.pilotCrewMembers = [];
    $scope.cabinCrewMembers = [];
    $scope.dhcCrewMembers = [];
    $scope.waterQuantity = null;
    $scope.supportsWaterUpliftAcType = false;
    $scope.crewRouteInfoPanel = {
        hasAircraftPositions: true,
        crewRouteDuties: []
    };

    /**
     * Checks if the client is online or offline 
     * @memberof SelectedFlightCtrl  
     */
    function checkConnectionStatus() {
        var isOnline = window.navigator.onLine;
        if (isOnline) {
            getFlightInfo();
        }
        else {
            showError("Please check your internet connection!");
        }
    }

    function getFlightInfo(){
        SearchFlightsFactory.getFlightInfo(flightId, flightDate, flightNo, departure) 
        .then(res => handleResponse(res))
        .catch(res => handleFailedResponse(res));
    }

    function handleResponse(res) {
        if(res.data.success){
            if ( res.data.data && res.data.data.Flight) {
                $scope.flightInfo = res.data.data;

                updateFlightInfoScopes(res.data.data);
                updateCrewMembersScopes();
                updatePaxPanelScopes();

                $scope.contentToShow = 'results';
                $scope.hasFlightInfo = true;
            }
            else {
                showError("Flight Info not found.");
            }
        }else{
            showError(res.data.errorMessage);
        }
    }

    function handleFailedResponse(res) {
        $scope.contentToShow = 'results';
        $scope.hasError = true;
        showError(res.errorMessage);
    }	

    /**
     * Displays the error message
     * @memberof SelectedFlightCtrl  
     * @param {string} message message to display
     */
    function showError(message) {
        $scope.contentToShow = "error";
        $scope.errorMessage = message;
    }

    function updateCrewMembersScopes(){
        $scope.pilotCrewMembers = $scope.flightInfo.CrewInfo.filter(x => (x.PositionCode == 'CP' || x.PositionCode == "FO") && !x.DHC);
        $scope.cabinCrewMembers = $scope.flightInfo.CrewInfo.filter(x => (x.PositionCode == 'SA' || x.PositionCode == "FA") && !x.DHC);
        $scope.dhcCrewMembers = $scope.flightInfo.CrewInfo.filter(x => x.DHC);
    }

    function updatePaxPanelScopes(){
        $scope.supportsWaterUpliftAcType = showRecomendedWaterAcTypes.includes($scope.flightInfo.AcType);
        getWaterQuantity();
    }
    
    function getWaterQuantity(){
        var totalPax = $scope.flightInfo.Flight.BOOKED_C + $scope.flightInfo.Flight.BOOKED_Y;
        var startDate = moment($scope.flightInfo.Flight.STD);
        var endDate = moment($scope.flightInfo.Flight.STA);
        var duration = moment.duration(endDate.diff(startDate)).asHours();
        var waterQuantity = (0,18 * totalPax * duration)/200;
        var formattedwaterQuantity = waterQuantity.toString().substring(0,4);
        $scope.waterQuantity = formattedwaterQuantity;
        if(waterQuantity){
            $scope.supportsWaterUpliftAcType = true;
        }
    }

    function updateFlightInfoScopes(flightInfoObj){
        var flight = {};
        flight.showPreviousAcPos = true;
        flight.showNextAcPos = true;
        flight.hasChangeAircraft = false;
        flight.DutyType = 'Flight';
        
        flight.FlightId = flightInfoObj.Flight.FlightId;
        flight.FlightNo = flightInfoObj.Flight.FlightNo;
        flight.Departure = flightInfoObj.Flight.DEP;
        flight.Arrival = flightInfoObj.Flight.ARR;
        flight.AcTailNo = flightInfoObj.Flight.Registration;
        flight.AcType = flightInfoObj.Flight.AcType;
        flight.DepartureStand = flightInfoObj.Flight.DEPSTAND;
        flight.ArrivalStand = flightInfoObj.Flight.ARRSTAND;
        flight.BookedC = flightInfoObj.Flight.BOOKED_C;
        flight.BookedY = flightInfoObj.Flight.BOOKED_Y;
        flight.ScheduledDeparture = flightInfoObj.Flight.STD;
        var STD = new Date(flight.ScheduledDeparture);
        flight.ScheduledDepartureDateUTC = STD.toString('yyyy-MM-dd');
        flight.ScheduledDepartureTimeUTC = STD.toString('HH:mm');
        flight.ScheduledArrival = flightInfoObj.Flight.STA;
        flight.CTOT = flightInfoObj.Flight.CTOT;
        flight.ETD = flightInfoObj.Flight.ETD;
        flight.ATD = flightInfoObj.Flight.ATD;
        flight.ETA = flightInfoObj.Flight.ETA;
        flight.ATA = flightInfoObj.Flight.ATA;
        flight.DepartureCountryISO = flightInfoObj.Flight.DepartureCountryISO;
        flight.ArrivalCountryISO = flightInfoObj.Flight.ArrivalCountryISO;
        flight.DepartureEU = flightInfoObj.Flight.DepartureEU;
        flight.ArrivalEU = flightInfoObj.Flight.ArrivalEU;
        flight.DepartureSchengen = flightInfoObj.Flight.DepartureSchengen;
        flight.ArrivalSchengen = flightInfoObj.Flight.ArrivalSchengen;
        
        var diffMin = Date.DifferenceInMinutes(flight.ScheduledDeparture, flight.ScheduledArrival);
        flight.BTime = Date.MinutesToStringSimple(diffMin);
    	flight.Delay = moment(flight.ATD).diff(moment(flight.ScheduledDeparture), 'minutes') || "";
	    flight.ArrDelay = moment(flight.ATA).diff(moment(flight.ScheduledArrival), 'minutes') || "";
        flight.flightDelays = {};
        flight.flightDelays.TotalDelay = flightInfoObj.FlightDelays.TotalDelay;
        flight.flightDelays.UnJustified = flightInfoObj.FlightDelays.UnJustified;
        flight.flightDelays.DC93 = flightInfoObj.FlightDelays.DC93;
        flight.flightDelays.DC9 = flightInfoObj.FlightDelays.DC9;
        //flight.crewMeals : no info
        
        flight.aircaftPositions = flightInfoObj.AircaftPositions;

        $scope.crewRouteInfoPanel.crewRouteDuties.push(flight);
    }

}})();